import { EntityItem } from "@adsk/docs-js-sdk";
import { Sheet } from "@adsk/acc-issues-core/sheets-service/SheetsApi";

export enum PlacementEntityType {
  FILES = "files",
  SHEETS = "sheets",
}

export type PlacementSheet = Sheet;

export type PlacementFile = EntityItem;

export enum PlacementFlowStatus {
  NOTHING_SELECTED,
  ENTITY_TYPE_SELECTED,
  ENTITY_SELECTED,
  ENTITY_ASSOCIATED,
}

export type EntityPickerModalEntity = {
  children?: EntityPickerModalEntity[];
  title: string;
  createTime: string;
  createUserId: string;
  createUserName: string;
  disabled: boolean;
  fileName?: string;
  fullPath?: string;
  hidden: boolean;
  urn: string;
  // there are more properties, you can add them here if needed.
};
